<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="&Scaron;tampač CS963">
     &Scaron;tampač CS963
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sr" title="Bezbednosne informacije">
     Bezbednosne informacije
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvencije">
      Konvencije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e43" title="Izjave o proizvodu">
      Izjave o proizvodu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_sr" title="Saznajte vi&scaron;e o &scaron;tampaču">
     Saznajte vi&scaron;e o &scaron;tampaču
    </a>
   </p>
   <div id="divd0e213">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sr" title="Pronalaženje informacija o &scaron;tampaču">
      Pronalaženje informacija o &scaron;tampaču
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_sr" title="Pronalaženje serijskog broja &scaron;tampača">
      Pronalaženje serijskog broja &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sr" title="Konfiguracije &scaron;tampača">
      Konfiguracije &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sr" title="Kori&scaron;ćenje kontrolne table">
      Kori&scaron;ćenje kontrolne table
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sr" title="Ikone na početnom ekranu">
      Ikone na početnom ekranu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_sr" title="Boje indikatora">
      Boje indikatora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sr" title="Lociranje bezbednosnog otvora">
      Lociranje bezbednosnog otvora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e715" title="Izbor papira">
      Izbor papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10494" title="Dodatne funkcije &scaron;tampača i podr&scaron;ka">
      Dodatne funkcije &scaron;tampača i podr&scaron;ka
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_sr" title="Postavljanje, instalacija i konfigurisanje">
     Postavljanje, instalacija i konfigurisanje
    </a>
   </p>
   <div id="divd0e10612">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_sr" title="Izbor lokacije za &scaron;tampač">
      Izbor lokacije za &scaron;tampač
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_sr" title="Portovi &scaron;tampača">
      Portovi &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#d0e10792" title="Konfigurisanje aplikacija i re&scaron;enja">
      Konfigurisanje aplikacija i re&scaron;enja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e10950" title="Pode&scaron;avanje i upotreba funkcija za pristupačnost">
      Pode&scaron;avanje i upotreba funkcija za pristupačnost
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_sr" title="Postavljanje papira i specijalnih medija">
      Postavljanje papira i specijalnih medija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11656" title="Instaliranje i ažuriranje softvera, upravljačkih programa i firmvera">
      Instaliranje i ažuriranje softvera, upravljačkih programa i firmvera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e11959" title="Instaliranje hardverskih opcija">
      Instaliranje hardverskih opcija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e13439" title="Umrežavanje">
      Umrežavanje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_sr" title="Obezbeđivanje &scaron;tampača">
     Obezbeđivanje &scaron;tampača
    </a>
   </p>
   <div id="divd0e13790">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sr" title="Brisanje memorije &scaron;tampača">
      Brisanje memorije &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_sr" title="Brisanje jedinice za skladi&scaron;tenje &scaron;tampača">
      Brisanje jedinice za skladi&scaron;tenje &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sr" title="Vraćanje podrazumevanih fabričkih postavki">
      Vraćanje podrazumevanih fabričkih postavki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_sr" title="Izjava o nepostojanosti">
      Izjava o nepostojanosti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_sr" title="&Scaron;tampanje">
     &Scaron;tampanje
    </a>
   </p>
   <div id="divd0e13980">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_sr" title="&Scaron;tampanje sa računara">
      &Scaron;tampanje sa računara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14031" title="&Scaron;tampanje sa mobilnog uređaja">
      &Scaron;tampanje sa mobilnog uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sr" title="&Scaron;tampanje sa fle&scaron; uređaja">
      &Scaron;tampanje sa fle&scaron; uređaja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sr" title="Konfigurisanje poverljivih zadataka">
      Konfigurisanje poverljivih zadataka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sr" title="&Scaron;tampanje poverljivih i drugih zadržanih zadataka">
      &Scaron;tampanje poverljivih i drugih zadržanih zadataka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_sr" title="&Scaron;tampanje liste uzoraka fontova">
      &Scaron;tampanje liste uzoraka fontova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_sr" title="&Scaron;tampanje liste direktorijuma">
      &Scaron;tampanje liste direktorijuma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_sr" title="Postavljanje listova separatora u zadacima &scaron;tampanja">
      Postavljanje listova separatora u zadacima &scaron;tampanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sr" title="Otkazivanje zadatka &scaron;tampe">
      Otkazivanje zadatka &scaron;tampe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_sr" title="Pode&scaron;avanje zatamnjenosti tonera">
      Pode&scaron;avanje zatamnjenosti tonera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_sr" title="Meniji &scaron;tampača">
     Meniji &scaron;tampača
    </a>
   </p>
   <div id="divd0e14526">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_sr" title="Mapa menija">
      Mapa menija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e14834" title="Uređaj">
      Uređaj
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e16744" title="&Scaron;tampanje">
      &Scaron;tampanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e18025" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e18302" title="USB jedinica">
      USB jedinica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e18566" title="Mreža/portovi">
      Mreža/portovi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e20688" title="Bezbednost">
      Bezbednost
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e21752" title="Usluge informatičkog oblaka">
      Usluge informatičkog oblaka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e21809" title="Izve&scaron;taji">
      Izve&scaron;taji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_sr" title="Re&scaron;avanje problema">
      <strong>
       Re&scaron;avanje problema
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_sr" title="Objedinjavanje obrazaca">
      <strong>
       Objedinjavanje obrazaca
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sr" title="&Scaron;tampanje stranice sa postavkama menija">
      &Scaron;tampanje
      <strong>
       stranice sa postavkama menija
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_sr" title="Opcije fini&scaron;era &scaron;tampača">
     Opcije fini&scaron;era &scaron;tampača
    </a>
   </p>
   <div id="divd0e22197">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_sr" title="Kori&scaron;ćenje fini&scaron;era za heftanje">
      Kori&scaron;ćenje fini&scaron;era za heftanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_sr" title="Kori&scaron;ćenje fini&scaron;era za heftanje i bu&scaron;enje rupa">
      Kori&scaron;ćenje fini&scaron;era za heftanje i bu&scaron;enje rupa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_sr" title="Kori&scaron;ćenje razdvajajućeg slagača">
      Kori&scaron;ćenje razdvajajućeg slagača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_sr" title="Kori&scaron;ćenje fini&scaron;era za bro&scaron;ure">
      Kori&scaron;ćenje fini&scaron;era za bro&scaron;ure
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_sr" title="Kori&scaron;ćenje prenosnika papira sa opcijom savijanja">
      Kori&scaron;ćenje prenosnika papira sa opcijom savijanja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sr" title="Održavanje &scaron;tampača">
     Održavanje &scaron;tampača
    </a>
   </p>
   <div id="divd0e22606">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_sr" title="Provera statusa delova i potro&scaron;nog materijala">
      Provera statusa delova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_sr" title="Konfigurisanje obave&scaron;tenja za potro&scaron;ni materijal">
      Konfigurisanje obave&scaron;tenja za potro&scaron;ni materijal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_sr" title="Pode&scaron;avanje upozorenja e-po&scaron;tom">
      Pode&scaron;avanje upozorenja e-po&scaron;tom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_sr" title="Generisanje izve&scaron;taja i evidencija">
      Generisanje izve&scaron;taja i evidencija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_sr" title="Naručivanje delova i potro&scaron;nog materijala">
      Naručivanje delova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e23205" title="Zamena delova i potro&scaron;nog materijala">
      Zamena delova i potro&scaron;nog materijala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e23794" title="Či&scaron;ćenje delova &scaron;tampača">
      Či&scaron;ćenje delova &scaron;tampača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e23908" title="U&scaron;teda energije i papira">
      U&scaron;teda energije i papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_sr" title="Preme&scaron;tanje &scaron;tampača na drugo mesto">
      Preme&scaron;tanje &scaron;tampača na drugo mesto
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_sr" title="Re&scaron;avanje problema">
     Re&scaron;avanje problema
    </a>
   </p>
   <div id="divd0e24043">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_sr" title="Problemi sa kvalitetom &scaron;tampe">
      Problemi sa kvalitetom &scaron;tampe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_sr" title="Kodovi gre&scaron;aka u &scaron;tampaču">
      Kodovi gre&scaron;aka u &scaron;tampaču
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e25218" title="Problemi sa &scaron;tampanjem">
      Problemi sa &scaron;tampanjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_sr" title="&Scaron;tampač ne reaguje">
      &Scaron;tampač ne reaguje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_sr" title="Nije moguće pročitati fle&scaron; uređaj">
      Nije moguće pročitati fle&scaron; uređaj
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_sr" title="Omogućavanje USB porta">
      Omogućavanje USB porta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_sr" title="Uklanjanje zaglavljivanja">
      Uklanjanje zaglavljivanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e27199" title="Problemi sa mrežnom vezom">
      Problemi sa mrežnom vezom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e27290" title="Problemi sa hardverskim opcijama">
      Problemi sa hardverskim opcijama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e27458" title="Problemi sa potro&scaron;nim materijalom">
      Problemi sa potro&scaron;nim materijalom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e27606" title="Problemi sa uvlačenjem papira">
      Problemi sa uvlačenjem papira
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e27800" title="Problemi sa kvalitetom boja">
      Problemi sa kvalitetom boja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sr" title="Kontaktiranje korisničke podr&scaron;ke">
      Kontaktiranje korisničke podr&scaron;ke
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_sr" title="Reciklaža i odlaganje">
     Reciklaža i odlaganje
    </a>
   </p>
   <div id="divd0e28024">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_sr" title="Recikliranje Lexmark proizvoda">
      Recikliranje Lexmark proizvoda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_sr" title="Recikliranje Lexmark pakovanja">
      Recikliranje Lexmark pakovanja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sr" title="Obave&scaron;tenja">
     Obave&scaron;tenja
    </a>
   </p>
   <div id="divd0e28058">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28061" title="Informacije o proizvodu">
      Informacije o proizvodu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28078" title="Obave&scaron;tenje o verziji">
      Obave&scaron;tenje o verziji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sr" title="Za&scaron;tićeni žigovi">
      Za&scaron;tićeni žigovi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sr" title="Obave&scaron;tenja o licenciranju">
      Obave&scaron;tenja o licenciranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sr" title="Nivoi emisije buke">
      Nivoi emisije buke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sr" title="Direktiva o električnom i elektronskom otpadu (WEEE)">
      Direktiva o električnom i elektronskom otpadu (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28176" title="Punjiva litijum-jonska baterija">
      Punjiva litijum-jonska baterija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sr" title="Уредба (ЕУ) 2023/1542">
      Уредба (ЕУ) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28213" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sr" title="Odlaganje proizvoda">
      Odlaganje proizvoda
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sr" title="Vraćanje kertridža kompanije Lexmark radi ponovne upotrebe ili reciklaže">
      Vraćanje kertridža kompanije Lexmark radi ponovne upotrebe ili reciklaže
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sr" title="Obave&scaron;tenje o osetljivosti na statički elektricitet">
      Obave&scaron;tenje o osetljivosti na statički elektricitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sr" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sr" title="Informacije o temperaturi">
      Informacije o temperaturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sr" title="Obave&scaron;tenje o laseru">
      Obave&scaron;tenje o laseru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sr" title="Potro&scaron;nja energije">
      Potro&scaron;nja energije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28474" title="Regulatorna obave&scaron;tenja za bežične proizvode">
      Regulatorna obave&scaron;tenja za bežične proizvode
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sr" title="Obave&scaron;tenje o modularnim komponentama">
      Obave&scaron;tenje o modularnim komponentama
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sr" title="Izloženost radiofrekventnom zračenju">
      Izloženost radiofrekventnom zračenju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28499" title="Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)">
      Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_sr" title="Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)">
      Usagla&scaron;enost sa direktivama Evropske zajednice (EZ)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_sr" title="Obave&scaron;tenje o radio smetnjama">
      Obave&scaron;tenje o radio smetnjama
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue